export function menusObjetoNormalize(row){
    return {
        idModulo: row.idModulo ?? row.IdModulo ?? row["idModulo"],
        idMenu: row.idMenu ?? row.IdMenu ?? row['IdMenu'] ?? 0,
        nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
        clave: row.clave ?? row.Clave ?? row["Clave"] ?? '',
        nivel: row.nivel ?? row.Nivel ?? row['Nivel'] ?? 0,
        idPadre: row.idPadre ?? row.IdPadre ?? row['IdPadre'] ?? null,
        orden: row.orden ?? row.Orden ?? row['Orden'] ?? 0,
        ruta: row.ruta ?? row.Ruta ?? row['Ruta'] ?? '',
        icono: row.icono ?? row.Icono ?? row['Icono'] ?? '',
        esRaizModulo: row.esRaizModulo ?? row.EsRaizModulo ?? row['EsRaizModulo'] ?? false
    }
}